import { ResellerItem } from '../redux/types';

const ASIN_TYPE = 'ASIN';
const UPC_TYPE = 'UPC';
const SKU_TYPE = 'SKU';

export const findResellerItem = (resellerItems: ResellerItem[], asin?: string): ResellerItem | undefined =>
    resellerItems.find((ri) => ri.asin === asin);

export const identifierTypeOf = (identifier: string, item: ResellerItem | undefined): string | undefined => {
    if (item?.asin === identifier) {
        return ASIN_TYPE;
    }
    if (item?.upc === identifier) {
        return UPC_TYPE;
    }
    if (item?.externalSku === identifier) {
        return SKU_TYPE;
    }
    return undefined;
};
